import http from "../../api";

export default {
  namespaced: true,
  actions: {
    getUsers({}, body) {
      return http.post("/customer/list", body);
    },
    getNewUsersCount({}) {
      return http.get("/customer/count-new");
    }
  }
};
 


// WEBPACK FOOTER //
// ./src/store/modules/main.js